<template>
    <div style="text-align: left;">
        <h1 class="notification" style="font-weight: 1500; font-size: 60px">
            Notices
        </h1>
        <ul style="padding: 30px">
            <li style="color: red" v-for="notice in notices" :key="notice">
                ◉ {{notice}}
            </li>
        </ul>
    </div>
</template>

<script>
import firebaseApp from '../firebaseConfig'

export default {
    data() {
        return {
            notices: ''
        }
    },
    // runs before the page loads
    beforeMount() {
        // get the collection "notice" and get all the documents from it
        firebaseApp.db.collection('notice').onSnapshot((doc) => {
            // Check if empty
            if(!doc.empty) {
                // if not, display all data on the webpage
                this.notices = []
                // loop over incoming data
                doc.forEach((notices) => {
                    // put them in the list
                    this.notices.push(notices.data().notice)
                })
            }
        })
    }
}
</script>